import React from "react";
import styled, { keyframes } from "styled-components";
import fipayFonts from "../../../theme/index";
import { colors } from "../../../theme/color";
import { IoMdLink } from "react-icons/io";
import { IoIosUnlock } from "react-icons/io";
import Button from "../../../components/Button/Button";
import { Header } from "../BankSelection";

export interface BankAccountConnectionProps {
  fipayLogo: string;
  stripeLogo: string;
  handleNext: () => void;
  onClickCloseIcon: () => void;
}
const BankAccountConnection: React.FC<BankAccountConnectionProps> = ({
  fipayLogo,
  stripeLogo,
  handleNext,
  onClickCloseIcon,
}) => {
  return (
    <>
      <Header $alignLeft>
        <img
          src="/assets/svg/x-alt.svg"
          alt="close-icon"
          onClick={onClickCloseIcon}
        />
      </Header>
      <IconWrapper>
        <img src={fipayLogo} alt="client logo" />
        <LinkLine />
        <img src={stripeLogo} alt="Stripe logo" />
      </IconWrapper>

      <Title>Centbit uses Fipay to connect your accounts</Title>
      <InnerWrap>
        <DescriptionWrapper>
          <Description>
            <IconImageWrap>
              <IoMdLink />
              <TextWrap>
                <span>Fast and simple</span>

                <span className="paragraph-text">
                  Connect your account in seconds.
                </span>
              </TextWrap>
            </IconImageWrap>
          </Description>
          <Description>
            <IconImageWrap>
              <IoIosUnlock />
              <TextWrap>
                <span>Your data is encrypted</span>
                <span className="paragraph-text">
                  Centbit can <a href="#">access data</a>. You can disconnect at
                  any time.
                </span>
              </TextWrap>
            </IconImageWrap>
          </Description>
        </DescriptionWrapper>
        <div>
          <Terms>
            By continuing, you agree to Fipay's <br />
            <a href="#"> Terms and Privacy Policy</a>
          </Terms>
          <ButtonWrapper>
            <Button
              title="Agree and continue"
              id={""}
              green
              padding={"10px 30px"}
              onClick={handleNext}
            />
          </ButtonWrapper>
        </div>
      </InnerWrap>
    </>
  );
};

export default BankAccountConnection;

const moveDots = keyframes`
  from {
    background-position: 0% 0%;
  }
  to {
    background-position: 100% 0%;
  }
`;

export const TextWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
export const IconImageWrap = styled.div`
  display: flex;
  gap: 1rem;
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const InnerWrap = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-between;
`;
export const LinkLine = styled.div`
  width: 50px;
  height: 2px;
  background-image: linear-gradient(
    90deg,
    ${colors.NAVYBLUE} 50%,
    transparent 0
  );
  background-size: 12px 2px;
  animation: ${moveDots} 3s linear infinite;
`;

export const Title = styled.h2`
  font-size: 25px;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
  color: ${colors.NAVYBLUE};
  font-family: "Gt Walsheim Pro", sans-serif;
  text-align: center;
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
`;
export const Description = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5rem;
  span {
    font-size: 14px;
    font-weight: 600;
  }
  .paragraph-text {
    font-size: 12px;
    font-weight: 400;
  }
`;
export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Terms = styled.p`
  text-align: center;
  font-size: 12px;
  color: #666;
  flex-wrap: wrap;

  a {
    color: #0056b3;
    text-decoration: none;
  }
`;
